import './Section.scss'
import { ISectionHeader, SectionHeader } from '../SectionHeader/SectionHeader'
import { Subtitle } from '../subtitle/subtitle'

interface ISecondarySection {
  borderBottom?: boolean
  headerConfig: ISectionHeader
  children?: React.ReactNode
}

export const Section = ({
  borderBottom = true,
  headerConfig,
  children,
}: ISecondarySection) => {
  return (
    <div
      className="section-container gradient-border"
      // style={borderBottom ? { borderBottom: '1px solid' } : {}}
    >
      <div className="gradient-border-content">
        <SectionHeader
          title={headerConfig.title}
          description={headerConfig.description}
          inLine={headerConfig.inLine}
          maxWidth={headerConfig.maxWidth}
        ></SectionHeader>
        <div>{children}</div>
      </div>
    </div>
  )
}
